import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteRole = {
  name: "deleteRole" as const,
  input: z.object({ roleId: zExt.objectId() }),
  output: z.null(),
};
